<template>
  <div id="app-carousel">
    <div class="carousel">
      <div class="carousel-box">
        <el-carousel height="550px">
          <el-carousel-item v-for="(image, index) in images" :key="index">
            <img
                :src="img.path"
                v-for="(img,imgindex) in image.pic_id_text"
                :key="imgindex"
              />
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      imgShow: 1,
      images:[]
    };
  },
  mounted() {
    this.$db.post(this.$url.website.ads.list).then(resp => {
      this.images = resp.data;
    });
  }
};
</script>
<style lang="scss" scoped>
#app-carousel {
  width: 100%;
}
.carousel {
  width: 100%;
  position: relative;
  margin-bottom: 40px;
  .carousel-box {
    width: 100%;
  }
}
.carousel-box /deep/ .el-carousel__indicators {
  bottom: 20px;
}
.carousel-box /deep/ .el-carousel__button {
  width: 10px;
  height: 10px;
  background-color: #ffffff;
  opacity: 0.5;
  border-radius: 50%;
}
.carousel-box /deep/ .el-carousel__indicator.is-active button {
  background-color: #b60205;
  opacity: 1;
}
.carousel-box /deep/ .el-carousel__item > img {
  width: 100%;
  height: 100%;
}
</style>




// WEBPACK FOOTER //
// src/view/Index/carousel.vue